export default function NotificationSettings() {
    return (
        <div className="text-base">
            <strong>Coming soon</strong>. Soon you will be able to manage your notification settings here.
        </div>
    );
}
